__turbopack_context__.v({
  "bottomCalloutDrawerPaper": "style-module-scss-module__QxMbfW__bottomCalloutDrawerPaper",
  "filterButton": "style-module-scss-module__QxMbfW__filterButton",
  "listings-count": "style-module-scss-module__QxMbfW__listings-count",
  "view-type-chip-button": "style-module-scss-module__QxMbfW__view-type-chip-button",
});
